// extracted by mini-css-extract-plugin
export default {"container":"UserProfile_container__gm-wH","changepasswordcontent":"UserProfile_changepasswordcontent__mLbRJ","savebtn":"UserProfile_savebtn__IS0n4"};